/**
 * Gets the initials from a name string.
 * For single names, returns the first letter.
 * For multiple names, returns first letter of first and last name.
 * Handles empty strings and whitespace.
 * @param name The full name string
 * @returns The initials in uppercase
 */
export const getInitials = (name: string): string => {
  if (!name?.trim()) return '';
  
  const names = name.trim().split(/\s+/);
  
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }

  const firstInitial = names[0].charAt(0);
  const lastInitial = names[names.length - 1].charAt(0);
  
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

export const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return '';

  phoneNumber = phoneNumber.slice(-2);
  
  phoneNumber = phoneNumber.padStart(10, '•');

  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
